import type { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import type { BimcCalculationSeasonData } from 'gql/graphql';

import { useMemo } from 'react';

import { bimcCalculationSeasonsGql } from '../calculationQueries';

export const useBimcCalculationSeasons = (
    calculationId: number | undefined,
    withEffect = true,
): [BimcCalculationSeasonData[], RequestStatus, any] => {
    const variables = useMemo(
        () => ({
            calculationId,
        }),
        [calculationId],
    );

    const [bimcCalculationSeasonsData, bimcCalculationSeasonsStatus, bimcCalculationSeasonsError] = useRequest({
        requestId: 'bimcCalculationSeasons',
        query: bimcCalculationSeasonsGql,
        withEffect: withEffect && Boolean(calculationId),
        variables,
    });

    const seasons = useMemo(
        () => bimcCalculationSeasonsData?.bimcCalculationSeasons || [],
        [bimcCalculationSeasonsData],
    );

    return [seasons, bimcCalculationSeasonsStatus, bimcCalculationSeasonsError];
};
